import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgUrl } from "@/lib/api";

export function ImageUpload({ value, onChange, testid, label = "Image" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      if (data?.url) onChange(data.url);
      toast.success("Image importée");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="h-20 w-20 shrink-0 overflow-hidden rounded-sm border border-[var(--line)] bg-[var(--ink-2)]">
        {value ? <img data-testid={`${testid}-preview`} src={imgUrl(value)} alt="" className="h-full w-full object-cover" /> : null}
      </div>
      <div className="flex-1">
        <span className="mb-1.5 block text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">{label}</span>
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={pick} className="hidden" data-testid={`${testid}-file`} />
        <button type="button" data-testid={`${testid}-button`} disabled={busy} onClick={() => ref.current?.click()} className="flex h-11 items-center gap-2 rounded-full border border-[var(--gold)]/60 px-5 text-xs uppercase tracking-[0.2em] text-[var(--gold-soft)] transition-colors hover:bg-[var(--gold)] hover:text-[var(--ink)] disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {value ? "Remplacer la photo" : "Importer une photo"}
        </button>
      </div>
    </div>
  );
}
